module.exports = __webpack_public_path__ + "static/media/ascending.ac8a5a7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/ascending.svg
// module id = 751
// module chunks = 0